import { appslistTypes } from './appslist.types';

const INITIAL_STATE = {
  data: null,
  isFetching: false,
  error: null,
  isPostDataComing: null,
  isPostDataError: null,
};

const appslistReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case appslistTypes.FETCH_APPS_LIST_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case appslistTypes.FETCH_APPS_LIST_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case appslistTypes.SAVE_APPS_LIST_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case appslistTypes.SAVE_APPS_LIST_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case appslistTypes.POST_APPS_LIST_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isPostDataComing: action.payload,
      };
    case appslistTypes.POST_APPS_LIST_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        isPostDataError: action.payload,
      };
    case appslistTypes.DELETE_APPS_LIST_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case appslistTypes.DELETE_APPS_LIST_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    case appslistTypes.MAKE_IS_FETCHING_TRUE:
      return {
        ...state,
        isFetching: true,
      };
    default:
      return state;
  }
};

export default appslistReducer;
